'use client';
import React from 'react';

import { useScrollWithOffset } from './useScrollWithOffset';
import { log } from '@/utils/logger';

interface AnchorProps {
  children: React.ReactNode;
  id: string;
  node?: { name: string; children: React.ReactNode[] };
  ref?: React.RefObject<HTMLDivElement>;
}

/**
 * scroll to anchor
 * @description accepts hash id or ref/node. where used anchor, dont add id to avoid default scroll behavior of browsers
 * @example <Anchor id="feedback_form">...</Anchor>
 * @example <Anchor ref={elementRef}>...</Anchor>
 * @example <Anchor node={node}>...</Anchor>
 */
export default function Anchor({ children, id, node, ref }: AnchorProps) {
  const anchorRef = React.useRef<HTMLElement>(null);
  const resolvedRef = ref || anchorRef;

  useScrollWithOffset({
    targetHash: id,
    elementRef: resolvedRef,
  });

  if (!id) {
    log.error('Anchor id is required');
    return <>{children}</>;
  }

  if (node) {
    const Tag = node.name as keyof JSX.IntrinsicElements;
    return (
      <Tag id={id} style={{ scrollMarginTop: '100px' }}>
        {children}
      </Tag>
    );
  }

  return (
    <div id={id} style={{ scrollMarginTop: '100px' }}>
      {children}
    </div>
  );
}
